<template>
  <div class="breadcrumbs">
    <div class="container">
      <ul class="breadcrumbs__container">
        <li>
          <router-link :to="{ name: 'home' }">
            <span>Главная</span>
            <pre> <IconComponent name="arrow-right"/>  </pre>
          </router-link>
        </li>
        <li v-for="(link, i) in links" :key="i">
          <router-link :to="link.route" v-if="link.route">
            <span>{{ link.title }}</span>
            <pre> <IconComponent name="arrow-right"/> </pre>
          </router-link>
          <span v-else>{{ link.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
export default {
  name: "BreadcrumbsComponent",
  components: { IconComponent },
  props: {
    links: Array,
  },
};
</script>

<style lang="stylus">
.breadcrumbs {
  display flex
  justify-content center
  align-items center
  margin-bottom 30px
  &__button {
    margin-right 16px
  }

  &__container {
    display flex
    align-items baseline
    overflow-x auto
    gap 7px

    &::-webkit-scrollbar {
      width: 0;
    }
    +below(860px) {
      align-items center
    }

    li {
      flex-shrink 0
      display flex
      align-items center

      a {
        font-weight: 400;
        font-size: 0.875em;
        line-height: 17px;
        color: rgba(31, 34, 41, 0.6);
        display: flex;
        align-items: center;
        transition var(--transition)
        gap 7px
        border-bottom 1px solid transparent
        +below(860px) {
          padding 2px 0
          //font-size: 1.125em
        }

        &:hover {
          //border-color inherit
          color var(--main)
        }

        .icon {
          width 20px
          //height 12px

          svg path {
            fill rgba(31, 34, 41, 0.6);
          }
        }
      }

      > span {
        font-weight: 400;
        font-size: 0.875em;
        line-height: 17px;
        display: flex;
        align-items: center;
        color: var(--black);
        text-decoration-line: underline;

        +below(860px) {
          //font-size: 1.125em
        }
      }
    }
  }

  .btn {
    flex-shrink 0
  }
}
</style>
